import {
  DiscountType,
  DiscountRangeType,
  IDiscountsContent,
  IExistingDiscount,
  IDuplicate,
  ILocation,
} from 'interfaces';
import { ICountry } from 'interfaces/location.model';
import { ICategory, ISubcategory } from '../Categories/categoriesTypes';

export enum discountSetActions {
  RESET_DISCOUNT_EDITOR = 'discountEditor/resetDiscountEditor',
}

export type ILogoImage = {
  name?: string;
  size?: number;
  data?: string;
  file?: File;
};

export type IMainInfoData = {
  companyName?: string;
  companyCategories?: ICategory[];
  companySubcategories?: ISubcategory[];
  discountType?: DiscountType;
  dateBegin?: string;
  isDateEnd?: boolean;
  dateEnd?: string | null;
  logoImage?: ILogoImage;
  tempImgUrl?: string;
};

export type IAboutFormData = {
  sizeMin?: number;
  sizeMax?: number;
  condition?: string;
  shortDiscountCondition?: string;
  more?: string;
  discountRangeType?: DiscountRangeType;
  discountName?: string;
  isArchived?: boolean;
};

export type IWarning = {
  similarDiscounts?: IDiscountsContent[];
  existingDiscount?: IExistingDiscount;
  existingDiscountID?: number;
  potentialDuplicate?: IDuplicate;
};

export type ICompanyInfoData = {
  phoneNumbers?: string;
  webSite?: string;
  address?: string;
  description?: string;
};

export type IEditData = {
  discountId?: number;
  companyId?: number;
  editVersion?: number;
};

export type IDiscountState = {
  discountCountry?: ICountry;
  selectedCities?: ILocation[];
  mainInfoData?: IMainInfoData;
  aboutFormData?: IAboutFormData;
  // shortDiscountCondition?: string;
  companyInfoData?: ICompanyInfoData;
  warning?: IWarning;
  editMode?: IEditData;
};
